module.exports = __webpack_public_path__ + "static/media/trimflow_field_side.e401ce52.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/trimflow_field_side.png
// module id = 329
// module chunks = 2